import type { JSX } from 'react'

import type { EmbedConfig } from 'api/config'
import { Button, Headline, Subtext } from 'components/Styled'

type MobileProps = {
  config: EmbedConfig
  onClose?: () => void
  onSubmit: () => void
}

export const Mobile = ({ config, onSubmit }: MobileProps): JSX.Element | null => {
  const phoneNumber = config.phone_number.trim()
  const communityMention = config.white_label_enabled ? '' : ' via Community'
  const body = encodeURIComponent(
    `Send this message for an invite to text with ${config.name}${communityMention} (Reference code: ${config.code})`,
  )
  return (
    <>
      <Headline>{config.headline}</Headline>
      <Subtext>{config.subtext}</Subtext>
      <Button as="a" href={`sms:${phoneNumber}?&body=${body}`} onClick={onSubmit} target="_top">
        Send Text
      </Button>
    </>
  )
}
